import IconMyOutfit from '@/assets/svg/ico_my_outfit.svg?react';
import IconGenerteOutfit from '@/assets/svg/ico_outfits_generate.svg?react';

export const TAB_BAR_WIDGET_MENU = [
    {
        id: 'my_outfits',
        title: 'Мои образы',
        icon: <IconMyOutfit />,
        action: 'myOutfits',
    },
    {
        id: 'create_new_outfit',
        title: 'Создать новый образ',
        icon: <IconGenerteOutfit />,
        action: 'createOutfit',
    },
];
